import React, { useState } from "react";
import { Accordion, AccordionSummary, Grid, TextField } from "@mui/material";
import styles from "./Translation.module.scss";
import ClearIcon from "@mui/icons-material/Clear";
import DoneIcon from "@mui/icons-material/Done";
import { LANCODES } from "../../common/Constants";

const NewComponentTranslation = (props) => {
  const [key, setKey] = useState("");
  const [en, setEn] = useState("");
  const [translatedValue, setTranslatedValue] = useState("");
  const [moduleKey, setModuleKey] = useState("");

  const lan = props.currentLan;

  const handleChangeKey = (event) => {
    setKey(event.target.value);
  };

  const handleChangeEn = (event) => {
    setEn(event.target.value);
  };

  const handleChangeTranslatedValue = (event) => {
    setTranslatedValue(event.target.value);
  };

  const handleChangeModuleKey = (event) => {
    setModuleKey(event.target.value);
  };

  const addComponentTranslation = () => {
    const updatedLanguage = {
      moduleKey: moduleKey,
      key: key,
      en: en,
      es: en,
      vi: en,
      th: en,
      ph: en,
      pt: en,
      [lan]: translatedValue,
    };
    props.addTranslationComponent(updatedLanguage);
  };

  const cancelComponentTranslation = () => {
    props.cancelTranslation();
  };

  return (
    <div>
      <br />
      {props.showNewComponentTranslationvalue && (
        <Accordion expanded={true}>
          <AccordionSummary>
            <Grid item md={3}>
              <TextField
                className={styles.inputField}
                type="text"
                name="topicBox"
                variant="outlined"
                placeholder={props.t("Translations.enterModule")}
                onChange={handleChangeModuleKey}
              />
            </Grid>
          </AccordionSummary>

          <Grid container className={styles.translation_header}>
            <Grid item md={3} className={styles.lanHeader}>
              {props.t("Translations.key")}
            </Grid>
            <Grid item md={3} className={styles.lanHeader}>
              {LANCODES["en"]}
            </Grid>
            <Grid item md={3} className={styles.lanHeader}>
              {LANCODES[props.languageSelected]}
            </Grid>
            <Grid item md={3} className={styles.lanHeader}>
              {props.t("Translations.action")}
            </Grid>
          </Grid>
          <div>
            <Grid container className={styles.lan}>
              <Grid item md={3}>
                <TextField
                  className={styles.inputField}
                  type="text"
                  name="topicBox"
                  variant="outlined"
                  placeholder={props.t("Translations.enterKey")}
                  onChange={handleChangeKey}
                />
              </Grid>

              <Grid item md={3}>
                <TextField
                  className={styles.inputField}
                  type="text"
                  name="topicBox"
                  variant="outlined"
                  placeholder={props.t("Translations.enterEng")}
                  onChange={handleChangeEn}
                />
              </Grid>

              <Grid item md={3}>
                <TextField
                  className={styles.inputField}
                  type="text"
                  name="topicBox"
                  variant="outlined"
                  placeholder={props.t("Translations.enterLan")}
                  onChange={handleChangeTranslatedValue}
                />
              </Grid>
              <Grid item md={3} className={styles.lanUpdate}>
                <DoneIcon
                  fontSize="small"
                  style={{ color: "green" }}
                  className={styles.button_hover}
                  onClick={addComponentTranslation}
                />
                <ClearIcon
                  fontSize="small"
                  style={{ color: "red" }}
                  className={styles.button_hover}
                  onClick={cancelComponentTranslation}
                />
              </Grid>
            </Grid>
          </div>
        </Accordion>
      )}
    </div>
  );
};

export default NewComponentTranslation;
